import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { TranslatorService } from '../../services/translator_service';

@Component({
  selector: 'app-forgot-password-modal',
  imports: [FormsModule,MatDialogModule],
  templateUrl: './forgot-password-modal.html',
  styleUrl: './forgot-password-modal.scss',
})
export class ForgotPasswordModal {
  translate;
	translationsObj;
	currentLang;
	model: any = {};
	pass_sent = false;

	constructor(
		private translator: TranslatorService,
		public dialogRef: MatDialogRef<ForgotPasswordModal>){
		this.translate = this.translator;
		this.translator.currentLangEmitter$
		.subscribe(async value=>{						
		  this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
		  this.currentLang = value;	
		})
	}

	ngOnInit() {
	}

	onCreatePass() {
		if (this.model.username) {
			this.pass_sent = true;
		}
	}
}
